<input
	type="text"
	[placeholder]="placeholder"
	class="form_element"
	numeric
	[decimal]="true"
	[required]="required"
	[disabled]="disabled"
	[value]="valueText"
	(blur)="changeEvent($any($event).target.value)"
/>
